var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 602,
    height: 602,
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 301,
    r: 300,
    fill: "#e42b38",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 301,
    r: 230,
    fill: "#005192",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#e42b38",
    strokeWidth: 45,
    fill: "none",
    d: "M95.939,95.939 506.061,506.061 M95.939,506.061 506.061,95.939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopForbidden);
export default __webpack_public_path__ + "static/media/stop_forbidden.5f258cfeefd092b95a66c83510f7f7f2.svg";
export { ForwardRef as ReactComponent };